import { gql } from '@apollo/client';

export const DELETE_INSTITUTION_FROM_INSTITUTION_PORTAL = gql`
  mutation DeleteInstitutionFromInstitutionPortal($id: ID!) {
    institution: deleteInstitutionFromInstitutionPortal(id: $id) {
      id
      name
    }
  }
`;
